import * as React from 'react';
import { errorHandler } from '../../../error/handler';
import { getStatoLavorazione, getStatoLavorazioneList } from '../../../fetch/dettaglio/attributes/statoLavorazione';
import { IStatoLavorazione } from '../../../interfaces/dettaglio/attributes/models';
import { normalizer } from '../../../lib/normalizer';
import { emptyAction, getAction, listAction } from '../../../store/dettaglio/attributes/statoLavorazione/actions';
import { IStatoLavorazioneState } from '../../../store/dettaglio/attributes/statoLavorazione/types';
import { useAppDispatch } from '../../../store/hooks';
import { endActionToDoAction, startActionToDoAction } from '../../../store/ui/actions';

export const useStatoLavorazioneGet = (id: number) => {
	const dispatch = useAppDispatch();
	React.useEffect(() => {
		const effect = async () => {
			if (!id) return;
			const actionToDo = 'get-stato-lavorazione';
			try {
				dispatch(startActionToDoAction({ actionToDo }));
				const statoLavorazione = await getStatoLavorazione(id);
				dispatch(getAction(statoLavorazione));
				dispatch(endActionToDoAction({ actionToDo, success: true }));
			} catch (err) {
				errorHandler(err, actionToDo);
			}
		}
		effect();
	}, [dispatch, id])
}

export const useStatoLavorazioneList = (query: number) => {
	const dispatch = useAppDispatch();
	React.useEffect(() => {
		const effect = async () => {
			if (!query) return;
			const actionToDo = 'list-stato-lavorazione';
			try {
				dispatch(startActionToDoAction({ actionToDo }));
				const { results, items: _items } = await getStatoLavorazioneList();
				_items.sort((itemA, itemB) => (!!itemA?.ordinamento && !!itemB.ordinamento) ? itemA.ordinamento - itemB.ordinamento : 0);
				const { list, items } = normalizer<number, IStatoLavorazione>(_items, "id");
				const actionPayload: IStatoLavorazioneState = {
					results,
					list,
					items
				}
				dispatch(listAction(actionPayload));
				dispatch(endActionToDoAction({ actionToDo, success: true }));
			} catch (err) {
				errorHandler(err, actionToDo);
			}
			return () => {
				dispatch(emptyAction());
			}
		}
		effect();
	}, [dispatch, query])
}
